var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupMessageWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 100,
    viewBox: "0 0 122 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3077 50.5495L112.795 83.5565C116.865 90.1145 112.287 98.616 104.571 98.8264L61.5385 100L17.25 98.8137C9.56908 98.608 4.98018 90.1766 8.97768 83.6147L29.1209 50.5495L52.8995 13.4709C56.8892 7.24963 66.0164 7.35665 69.8592 13.6698L92.3077 50.5495Z",
    fill: "#FB8C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5385 41.2079C64.573 41.2079 67.033 38.7479 67.033 35.7134C67.033 32.6788 64.573 30.2189 61.5385 30.2189C58.5039 30.2189 56.0439 32.6788 56.0439 35.7134C56.0439 38.7479 58.5039 41.2079 61.5385 41.2079ZM61.5382 46.7032C59.1106 46.7032 57.1426 48.6712 57.1426 51.0988V80.7692C57.1426 83.1968 59.1106 85.1648 61.5382 85.1648C63.9658 85.1648 65.9338 83.1968 65.9338 80.7692V51.0989C65.9338 48.6712 63.9658 46.7032 61.5382 46.7032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupMessageWarning);
export default __webpack_public_path__ + "static/media/popup-message-warning.6be86b4d3462eecf37a62f7257f7fd48.svg";
export { ForwardRef as ReactComponent };